// extracted by mini-css-extract-plugin
export default {"scrollContainer":"jsonInfo_scrollContainer__dla92","titre":"jsonInfo_titre__T4Fdf","divider":"jsonInfo_divider__XUa8n"};